import { AsarFormikInput } from "@/components";
import { Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { SectionCheckBox } from "./SectionCheckBox";
import Sections from "./Sections";
import { useFormikContext } from "formik";

function GroupSection({ initSections, update = false }) {
  const [Arr, setArr] = useState(initSections);
  const { values, setValues } = useFormikContext();

  useEffect(() => {
    setValues({ ...values, medicalExpertises: Arr });
  }, [Arr]);

  return (
    <>
      <Grid
        display={"flex"}
        flexDirection={"column"}
        gap={"10px"}
        width={"100%"}
      >
        <AsarFormikInput
          name={"screeningSicknesses"}
          label={"غربالگری بیماری های شایع دارید؟"}
          placeholder="بیماری هایی را که غربال می کنید نام ببرید."
        />
        <AsarFormikInput
          name={"donateMedicine"}
          label={"اهدای رایگان دارو دارید؟"}
          placeholder="به طور متوسط چند قلم دارو همراه دارید؟."
        />

        <AsarFormikInput
          name={"publicDoctors"}
          label={"پزشک عمومی دارید؟"}
          placeholder="تعداد پزشک‌های عمومی تیم را وارد کنید.."
        />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"بخش‌ها"}
        </Typography>
        <Typography fontSize="13px" color="#5E5E5E">
          {
            "در صورت حضور بخش‌های زیر در گروه جهادی‌تان، آن موارد را علامت بزنید. در غیر این صورت، آن را خالی رها کنید."
          }
        </Typography>

        <Sections dataForm={values} setDataForm={setValues} update={update} />

        <Typography
          color="var(--emr-primary)"
          fontSize="18px"
          pb={"2px"}
          borderBottom={`1px solid var(--emr-primary)`}
        >
          {"بخش‌ها"}
        </Typography>
        <Typography fontSize="13px" color="#5E5E5E">
          {
            "در صورتی که گروه جهادی‌تان در حوزه‌های پزشکی زیر تخصص دارد، آن موارد را علامت بزنید. در غیر این صورت آن را خالی رها کنید."
          }
        </Typography>

        <Grid
          display={"flex"}
          flexDirection={"row"}
          gap={"5px"}
          flexWrap={"wrap"}
          rowGap={"5px"}
          width={"100%"}
          mr={"-25px"}
        >
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "INNER"]);
              } else {
                setArr(Arr.filter((item) => item !== "INNER"));
              }
            }}
            checked={Arr?.includes("INNER")}
            label="داخلی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "INFANT"]);
              } else {
                setArr(Arr.filter((item) => item !== "INFANT"));
              }
            }}
            label="اطفال"
            checked={Arr?.includes("INFANT")}
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "EAR"]);
              } else {
                setArr(Arr.filter((item) => item !== "EAR"));
              }
            }}
            checked={Arr?.includes("EAR")}
            label="گوش و حلق و بینی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "ORTHOPEDICS"]);
              } else {
                setArr(Arr.filter((item) => item !== "ORTHOPEDICS"));
              }
            }}
            checked={Arr?.includes("ORTHOPEDICS")}
            label="ارتوپدی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "UROLOGY"]);
              } else {
                setArr(Arr.filter((item) => item !== "UROLOGY"));
              }
            }}
            checked={Arr?.includes("UROLOGY")}
            label="ارولوژی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "RADIOLOGY"]);
              } else {
                setArr(Arr.filter((item) => item !== "RADIOLOGY"));
              }
            }}
            checked={Arr?.includes("RADIOLOGY")}
            label="رادیولوژی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "SKIN"]);
              } else {
                setArr(Arr.filter((item) => item !== "SKIN"));
              }
            }}
            checked={Arr?.includes("SKIN")}
            label="پوست"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "NERVES"]);
              } else {
                setArr(Arr.filter((item) => item !== "NERVES"));
              }
            }}
            checked={Arr?.includes("NERVES")}
            label="اعصاب"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "WIFE"]);
              } else {
                setArr(Arr.filter((item) => item !== "WIFE"));
              }
            }}
            checked={Arr?.includes("WIFE")}
            label="زنان"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "EYE"]);
              } else {
                setArr(Arr.filter((item) => item !== "EYE"));
              }
            }}
            checked={Arr?.includes("EYE")}
            label="چشم"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "SURGERY"]);
              } else {
                setArr(Arr.filter((item) => item !== "SURGERY"));
              }
            }}
            checked={Arr?.includes("SURGERY")}
            label="جراحی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "INFECTION"]);
              } else {
                setArr(Arr.filter((item) => item !== "INFECTION"));
              }
            }}
            checked={Arr?.includes("INFECTION")}
            label="عفونی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "PSYCHIATRY"]);
              } else {
                setArr(Arr.filter((item) => item !== "PSYCHIATRY"));
              }
            }}
            checked={Arr?.includes("PSYCHIATRY")}
            label="روانپزشکی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "PHYSICAL"]);
              } else {
                setArr(Arr.filter((item) => item !== "PHYSICAL"));
              }
            }}
            checked={Arr?.includes("PHYSICAL")}
            label="فیزیکی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "PHYSICAL_MEDICINE"]);
              } else {
                setArr(Arr.filter((item) => item !== "PHYSICAL_MEDICINE"));
              }
            }}
            checked={Arr?.includes("PHYSICAL_MEDICINE")}
            label="طب فیزیکی"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "SOCIAL_MEDICINE"]);
              } else {
                setArr(Arr.filter((item) => item !== "SOCIAL_MEDICINE"));
              }
            }}
            checked={Arr?.includes("SOCIAL_MEDICINE")}
            label="پزشکی اجتماعی و بهداشت"
          />
          <SectionCheckBox
            onChange={(e) => {
              if (e.target.checked === true) {
                setArr([...Arr, "SPORT_MEDICINE"]);
              } else {
                setArr(Arr.filter((item) => item !== "SPORT_MEDICINE"));
              }
            }}
            checked={Arr?.includes("SPORT_MEDICINE ")}
            label="طب ورزشی"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default GroupSection;
